import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const ScheduledEmailsLazy = lazy(() =>
  import("./ScheduledEmails").then((module) => ({ default: module.ScheduledEmails })),
);

export const ScheduledEmailsAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <ScheduledEmailsLazy />
  </Suspense>
);
